export type MunicipalityOption = { value: string; label: string };

export const atticaMunicipalities: MunicipalityOption[] = [
// Κεντρικός Τομέας Αθηνών
{ value: "athina", label: "Αθήνα" },
{ value: "dafni_ymittos", label: "Δάφνη-Υμηττός" },
{ value: "galatsi", label: "Γαλάτσι" },
{ value: "kaisariani", label: "Καισαριανή" },
{ value: "vyronas", label: "Βύρωνας" },
{ value: "zografou", label: "Ζωγράφου" },
{ value: "ilioupoli", label: "Ηλιούπολη" },
{ value: "filadelfeia_chalkidona", label: "Φιλαδελφείας-Χαλκηδόνος" },

  // Βόρειος Τομέας Αθηνών
  { value: "agia_paraskevi", label: "Αγία Παρασκευή" },
  { value: "irakleio", label: "Ηράκλειο Αττικής" },
  { value: "kifisia", label: "Κηφισιά" },
  { value: "lykovrysi_pefki", label: "Λυκόβρυση-Πεύκη" },
  { value: "marousi", label: "Μαρούσι" },
  { value: "metamorfosi", label: "Μεταμόρφωση" },
  { value: "nea_ionia", label: "Νέα Ιωνία" },
  { value: "papagou_cholargos", label: "Παπάγου-Χολαργός" },
  { value: "penteli", label: "Πεντέλη" },
  { value: "vrilissia", label: "Βριλήσσια" },
  { value: "chalandri", label: "Χαλάνδρι" },
  { value: "filothei_psychiko", label: "Φιλοθέη-Ψυχικό" },

// Δυτικός Τομέας Αθηνών
{ value: "agia_varvara", label: "Αγία Βαρβάρα" },
{ value: "aigaleo", label: "Αιγάλεω" },
{ value: "agioi_anargyroi_kamatero", label: "Άγιοι Ανάργυροι-Καματερό" },
{ value: "chaidari", label: "Χαϊδάρι" },
{ value: "ilion", label: "Ίλιον" },
{ value: "peristeri", label: "Περιστέρι" },
{ value: "petroupoli", label: "Πετρούπολη" },

  // Νότιος Τομέας Αθηνών
  { value: "agios_dimitrios", label: "Άγιος Δημήτριος" },
  { value: "alimos", label: "Άλιμος" },
  { value: "elliniko_argyroupoli", label: "Ελληνικό-Αργυρούπολη" },
  { value: "glyfada", label: "Γλυφάδα" },
  { value: "kallithea", label: "Καλλιθέα" },
  { value: "moschato_tavros", label: "Μοσχάτο-Ταύρος" },
  { value: "nea_smyrni", label: "Νέα Σμύρνη" },
  { value: "palaio_faliro", label: "Παλαιό Φάληρο" },
  { value: "vari_voula_vouliagmeni", label: "Βάρη-Βούλα-Βουλιαγμένη" },

  // Περιφερειακή Ενότητα Πειραιά
  { value: "piraeus", label: "Πειραιάς" },
  { value: "keratsini_drapetsona", label: "Κερατσίνι-Δραπετσώνα" },
  { value: "korydallos", label: "Κορυδαλλός" },
  { value: "nikaia_agios_ioannis_rentis", label: "Νίκαια-Άγιος Ιωάννης Ρέντης" },
  { value: "perama", label: "Πέραμα" },

  // Ανατολική Αττική
  { value: "acharnes", label: "Αχαρνές" },
  { value: "dionysos", label: "Διόνυσος" },
  { value: "kropia", label: "Κρωπία" },
  { value: "lavreotiki", label: "Λαυρεωτική" },
  { value: "marathonas", label: "Μαραθώνας" },
  { value: "markopoulo_mesogaias", label: "Μαρκόπουλο Μεσογαίας" },
  { value: "oropos", label: "Ωρωπός" },
  { value: "paiania", label: "Παιανία" },
  { value: "pallini", label: "Παλλήνη" },
  { value: "rafina_pikermi", label: "Ραφήνα-Πικέρμι" },
  { value: "saronikos", label: "Σαρωνικός" },
  { value: "spata_artemida", label: "Σπάτα-Αρτέμιδα" },

  // Δυτική Αττική
  { value: "aspropyrgos", label: "Ασπρόπυργος" },
  { value: "elefsina", label: "Ελευσίνα" },
  { value: "fyli", label: "Φυλή" },
  { value: "megara", label: "Μέγαρα" },
  { value: "mandra_eidyllia", label: "Μάνδρα-Ειδυλλία" },

  // Νήσων (περιφερειακή ενότητα)
  { value: "aegina", label: "Αίγινα" },
  { value: "agistri", label: "Αγκίστρι" },
  { value: "salamina", label: "Σαλαμίνα" },
  { value: "troizinia_methana", label: "Τροιζηνία-Μέθανα" },
  { value: "kythira", label: "Κύθηρα" },
  { value: "spetses", label: "Σπέτσες" },
  { value: "hydra", label: "Ύδρα" },
  { value: "poros", label: "Πόρος" },
];
